import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import { TinymceEditorComponent } from '../tinymce-editor/tinymce-editor.component'
import Swal from 'sweetalert2'

@Component({
	selector: 'extract-text-web',
	templateUrl: './extract-text-web.component.html',
	styleUrls: ['./extract-text-web.component.scss']
})

export class ExtractTextWebComponent implements OnInit, OnDestroy {

	userID = 0

	courseID = 0
	courseUnits: any[] = []
	selectedUnit = -1
	unitLessons: any[] = []
	selectedLesson = -1
	lessonHeadings: any[] = []
	selectedHeading = -1
	selectedHeadingContent = ''
	
	// webUrl = ''
	// webUrl = 'https://www.escuelacoaching.com/que-es-coaching-ser-coach/'
	webUrl = 'https://www.xataka.com/robotica-e-ia/que-inteligencia-artificial'
	webContent = ''
	webContentTitle = ''
	plain = true
	newLessonName = ''

	webExtracting = false
	webExtractSuccess = false
	webExtractError = false
	webExtractResultText = ''

	nextStep = ''
	nextStepLoading = false
	nextStepSuccess = false
	nextStepError = false

	extractTextWebSub = new Subscription
	showCourseSub = new Subscription
	taskStatusCelerySub = new Subscription
	insertNodeSub = new Subscription
	updateHeadingSub = new Subscription

	@ViewChild(TinymceEditorComponent) tinymceEditor: any
	webContentEditorId = 'web-content-editor'
	
	constructor(private dataService: ApiService, private actRoute: ActivatedRoute) { }

	ngOnInit(): void {
		this.userID = this.dataService.getUserID()
		this.courseID = +this.actRoute.snapshot.paramMap.get('id')!
	}

	ngAfterViewInit(): void {
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				this.courseUnits = course.units
			},
			_error => {
				// console.log(error)
			},
		)
	}

	ngOnDestroy(): void {
		this.extractTextWebSub?.unsubscribe()
		this.showCourseSub?.unsubscribe()
		this.taskStatusCelerySub?.unsubscribe()
		this.insertNodeSub?.unsubscribe()
	}

	selectUnit(unitId: number): void {
		this.unitLessons = this.courseUnits?.find((unit) => {
			return +unitId === +unit.id
		})?.lessons!

		this.selectedLesson = -1
		this.selectedHeading = -1
		this.lessonHeadings = []
		this.newLessonName = `Lección ${this.unitLessons.length + 1}: `

		if (this.unitLessons?.length === 1) {
			this.selectLesson(this.unitLessons[0].id)
		}
	}

	selectLesson(lessonId: number): void {
		this.lessonHeadings = this.unitLessons?.find((lesson) => {
			return +lessonId === +lesson.id
		})?.headings!

		this.selectedLesson = +lessonId
		this.selectedHeading = -1

		if (this.lessonHeadings?.length === 1) {
			this.selectHeading(this.lessonHeadings[0].id)
		}
	}

	selectHeading(headingId: number): void {
		this.selectedHeading = +headingId
		this.selectedHeadingContent = this.lessonHeadings?.find((heading) => {
			return +headingId === +heading.id
		})?.content!
	}

	extractTextWebStatus(status: 'loading' | 'error' | 'success') {
		this.webExtracting = status == 'loading'
		this.webExtractError = status == 'error'
		this.webExtractSuccess = status == 'success'
	}

	extractTextWeb() {
		if (this.webUrl == '') {
			Swal.fire('Error', 'Por favor, introduza un sitio web.', 'error')
			return
		}

		this.webContent = ''
		this.webContentTitle = ''
		this.extractTextWebStatus('loading')

		this.extractTextWebSub = this.dataService.extractTextWeb(this.webUrl, this.plain)
		.subscribe(
			data => {
				// console.log(data)

				let task = data.id
				let interval = 1000 * 60 * 0.07
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery('webtext', task)
					.subscribe(
						data => {
							// console.log(data)
							let status = data.status
							// this.activitiesResult = data.result.activity_list

							if (status !== "STARTED") {

								window.clearTimeout(idinterval)
								this.webExtracting = false
								this.webExtractResultText = data.result.message

								if (status === "ERROR") {
									// window.clearTimeout(idinterval)
									this.webExtractResultText = 'ERROR: No se ha podido extraer el contenido. Por favor, revise el enlace o intente con otro enlace.' 
									this.extractTextWebStatus('error')
									return
								}

								if (status === "SUCCESS") {
									this.extractTextWebStatus('success')
								}

								let result = data.result
								this.webContentTitle = result.title
								if (this.plain) {
									let textArr = result.text[0].valor
									textArr.forEach((line: any) => {
										this.webContent += `<p>${line}</p>`
									})
								} else {
									let textArr = result.text
									textArr.forEach((line: any) => {
										console.log(line)
										let type = line.tipo
										let content = line.valor
										if (type == 'texto') {
											content.forEach((sentence: any) => {
												this.webContent += `<p>${sentence}</p>`
											})
										} else {
											this.webContent += `<${type}>${content[0]}</${type}>`
										}
									})
								}

							}

						},
						_error => {
							// console.log(error)
							window.clearTimeout(idinterval)
							this.extractTextWebStatus('error')
						},
					)
				}, interval)
			},
			_error => {
				// console.log(error)
				this.extractTextWebStatus('error')
			},
		)
	}

	extractTextWebNextStepStatus(status: 'loading' | 'error' | 'success') {
		this.nextStepLoading = status == 'loading'
		this.nextStepError = status == 'error'
		this.nextStepSuccess = status == 'success'

		if (status == 'success' || status == 'error') {
			// this.selectedUnit = -1
			// this.selectedLesson = -1
		}
	}

	extractTextWebNextStep() {
		this.extractTextWebNextStepStatus('loading')
		// console.log(this.nextStep)
		// console.log(this.selectedUnit)
		// console.log(this.selectedLesson)
		// console.log(this.selectedHeading)

		this.webContent = this.tinymceEditor.content

		if (this.nextStep == 'new-lesson') {
			this.insertNodeSub = this.dataService.insertNode(this.newLessonName, 'lesson', this.unitLessons.length, this.selectedUnit)
			.subscribe(
				lessonID => {
					// console.log(lessonID)
					this.insertNodeSub = this.dataService.insertNode(this.webContentTitle, 'heading', 0, lessonID)
					.subscribe(
						headingID => {
							// console.log(headingID)
							this.updateHeadingSub = this.dataService.updateHeading(headingID, undefined, this.webContent)
							.subscribe(
								_data => {
									// console.log(data)
									this.extractTextWebNextStepStatus('success')
								},
								_error => {
									// console.log(error)
									this.extractTextWebNextStepStatus('error')
								},
							)
						},
						_error => {
							// console.log(error)
							this.extractTextWebNextStepStatus('error')
						},
					)
				},
				_error => {
					// console.log(error)
					this.extractTextWebNextStepStatus('error')
				},
			)

		} else if (this.nextStep == 'new-heading') {
			this.insertNodeSub = this.dataService.insertNode(this.webContentTitle, 'heading', this.unitLessons.length, this.selectedLesson)
			.subscribe(
				headingID => {
					// console.log(headingID)
					this.updateHeadingSub = this.dataService.updateHeading(headingID, undefined, this.webContent)
					.subscribe(
						_data => {
							// console.log(data)
							this.extractTextWebNextStepStatus('success')
						},
						_error => {
							// console.log(error)
							this.extractTextWebNextStepStatus('error')
						},
					)
				},
				_error => {
					// console.log(error)
					this.extractTextWebNextStepStatus('error')
				},
			)
		} else {

			let newHeadingContent = ''
			if (this.nextStep == 'replace') {
				newHeadingContent = this.webContent
			} else if (this.nextStep == 'top') {
				newHeadingContent = this.webContent + this.selectedHeadingContent
			} else if (this.nextStep == 'bottom') {
				newHeadingContent = this.selectedHeadingContent + this.webContent
			}

			this.updateHeadingSub = this.dataService.updateHeading(this.selectedHeading, undefined, newHeadingContent)
			.subscribe(
				_data => {
					// console.log(data)
					this.extractTextWebNextStepStatus('success')
				},
				_error => {
					// console.log(error)
					this.extractTextWebNextStepStatus('error')
				},
			)

		}
	}

}